import React from 'react';
import { Table, Icon, Button, Alert, Popconfirm, Checkbox, message, Upload } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import ModalUsers from '../../components/ModalUsers'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import moment from 'moment';
import Papa from 'papaparse/papaparse.min.js'
import axios from 'axios';
import { pathOr } from 'ramda';
import { fbFunctionsURL, environment, serviceTracker_allowed } from '../../config.js'
import Parser from 'html-react-parser';
const CheckboxGroup = Checkbox.Group;


class SchoolAdminTeacher extends React.Component {

  constructor() {
    super();
    this.state = {
      modalOpen: false,
      modalData: null,
      modalMode: null,
      toRemove: null,
      sortRegistered: null,
      sortInvited: null,
      products: null,
      selectedRowKeys: [],
      subscribeProducts: null,
      errorMessage: null,
      checked: []
    }
  }

  componentDidMount = () => {
    const schoolId = this.props.profile.profile.school.id
    this.props.firebase.database().ref('schools/' + schoolId).on('value', (snapshot) => {
      const val = snapshot.val();
      this.setState({ subscribeProducts: val.products })
    })
  }

  checkRecord = (checked, record, invited) => {

    let checked_ids = []

    if (invited) { //Select or deselect all
      if (checked) {
        invited.map( item => checked_ids.push(item.id))
      }
    } else { //Only one selected
      checked_ids = this.state.checked
      if (checked) {
        checked_ids.push(record.id)
      } else {
        checked_ids = checked_ids.filter(key =>
          key !== record.id
        )
      }
    }
    this.setState({ checked: checked_ids })
  }

  resendInvites = () => {
    const { t } = this.props
    const checked = this.state.checked
    const schoolId = this.props.profile.profile.school.id
    checked.map(uid => {
      axios.post(`${fbFunctionsURL}/resendInvite`, {
        uid,
        schoolId,
        environment: 'production'
      })
    })
    message.success(t('Invites resent'))
  }
  removeEntry = (e) => {
    if (this.state.toRemove) {
      let uid = this.state.toRemove
      this.props.firebase.database().ref('users/' + uid).update({
        active: false,
        student_id: ''
      });
      this.props.firebase.database().ref('users/' + uid + '/profile').update({
        name: '',
        last_name: '',
        email: ''
      });
      this.setState({ toRemove: null })
    }
  }

  changeAuthInfo = (type, uid, value) => {
    this.props.firebase.auth().currentUser.getIdToken()
      .then(token => {
        let data = { uid }
        if (type === 'password') {
          data.password = value
        } else {
          data.email = value
        }

        const config = {
          url: type === 'password' ? `${fbFunctionsURL}/register/changePassword` : `${fbFunctionsURL}/register/changeEmail`,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${token}`
          }
        }
        axios(config)
      })
  }

  saveModal = (data, mode) => {

    const { t } = this.props
    const { subscribeProducts, modalData } = this.state


    if (modalData && modalData.invited && data.customId !== modalData.customId) {
      this.changeAuthInfo('password', modalData.id, data.customId)
    }

    if (modalData && modalData.invited && data.email !== modalData.email) {
      this.changeAuthInfo('email', modalData.id, data.email)
    }

    const users = Object.entries(this.props.users)
    if (serviceTracker_allowed && (!data.products || data.products.length === 0)) {
      message.error('Please select a product')
      return
    }
    if (data.first === '') {
      message.error('First name is required!')
      return
    }
    if (data.last === '') {
      message.error('Last name is required!')
      return
    }
    if (data.email === '') {
      message.error('Email is required!')
      return
    }

    const isRegistered = users.filter(user =>
      user[1].profile.email == data.email
    ).length !== 0

    if (isRegistered && mode !== 'edit') {
      message.error(`${data.email} is already exist.`)
      return
    }

    if (data.customId === '') {
      message.error('TeacherId is required!')
      return
    }
    if (data.customId.length < 6) {
      message.error('TeacherId has to be at least 6 characters')
      return
    }

    let dob = moment(data.birth).format('DD/MM/YYYY')
    if (serviceTracker_allowed && (!subscribeProducts || subscribeProducts.length === 0)) {
      message.error('You must select at least one product to subscribe for!')
      return
    }
    const notSubscribed = data.products && data.products.filter(item => !subscribeProducts.includes(item))
    if (serviceTracker_allowed && notSubscribed.length > 0) {
      message.error(`Teacher is not allowed to use ${notSubscribed}, because his school did not subscribe for this product.`)
      return
    }
    this.modal.cancel();

    if (mode == 'edit') {
      this.props.firebase.database().ref('users/' + data.id + '/profile').update({
        name: data.first,
        last_name: data.last,
        email: data.email,
        id: data.customId,
        products: data.products
      })
      if (serviceTracker_allowed && data.savedProduct !== data.products) {
        this.props.firebase.database().ref('users/' + data.id + '/profile').update({
          updateProductDate: Date.now()
        })
      }
    } else {
      let school = {};
      school.id = this.props.profile.profile.school.id;
      school.name = this.props.profile.profile.school.name
      this.props.firebase.auth().currentUser.getIdToken()
        .then( token => {
          const config = {
            url: `${fbFunctionsURL}/register/registerUser`,
            method: 'post',
            data: {
              'email': data.email,
              'name': data.first,
              'last_name': data.last,
              'id': data.customId,
              'role': 'teacher',
              'school_id': school.id,
              'school_name': school.name,
              'products': data.products
            },
            headers: {
              authorization: `Bearer ${token}`
            }
          }
          axios(config).then(() => {
            message.success(t('Teacher invited!'));
          })
        })
    }
  }

  cancelModal = () => {
    this.setState({ modalOpen: false, modalData: null })
  }

  openModal = (mode, data) => {
    this.setState({ modalOpen: true, modalData: data, modalMode: mode },
      () => {
        this.modal.updateData();
      })
  }

  handleRegistered = (pagination, filters, sorter) => {
    this.setState({ sortRegistered: sorter });
  }

  handleInvited = (pagination, filters, sorter) => {
    this.setState({ sortInvited: sorter });
  }

  importData = (file) => {
    const _this = this
    Papa.parse(file.file, {
      header: true,
      download: false,
      skipEmptyLines: true,
      complete: function (results) {
        _this.saveCSV(results.data);
      }
    });
  }
  onChangeCheckbox = (checkedValues) => {
    this.setState({ products: checkedValues })
  }
  onCloseAlert = () => {
    this.setState({ errorMessage: '' })

  }
  groupChange = (selectedRowKeys) => {
    const { products, subscribeProducts } = this.state
    let errorMessage = ''
    if (products.length === 0) {
      errorMessage = 'Please select a product'
      message.error(errorMessage)
      return
    }
    const notSubscribed = products && products.filter(item => !subscribeProducts.includes(item))
    if (notSubscribed.length > 0) {
      errorMessage = `Teachers is not allowed to use ${notSubscribed}, because his school did not subscribe for this product.`
      message.error(errorMessage)
      return
    }
    else {
      selectedRowKeys.map((item, i) => {
        this.props.firebase.database().ref('users/' + item + '/profile').update({
          products: products,
          updateProductDate: Date.now()
        })
      })
      message.success('Teachers products has been changed successfully!')
    }

  }

  validateId = id => {
    if (id.length > 5) {
      return id
    } else if (id.length == 5) {
      return `${id}0`
    } else if (id.length == 4) {
      return `${id}00`
    } else if (id.length == 3) {
      return `${id}000`
    } else if (id.length == 2) {
      return `${id}0000`
    } else if (id.length == 1) {
      return `${id}00000`
    }
  }

  saveCSV = (data) => {
    const { t } = this.props
    const { subscribeProducts } = this.state
    const users = Object.entries(this.props.users)
    const schoolId = this.props.profile.profile.school.id;
    const schoolName = this.props.profile.profile.school.name
    let errorCount = 0
    let errorMessage = ''
    if (!subscribeProducts || subscribeProducts.length === 0) {
      return message.error("You must select at least one product to subscribe for")
    }
    data.map(invite => {
      const isRegistered = users.filter(user =>
        user[1].profile.email == invite['Email Address']
      ).length !== 0

      const productsColumn = invite['Products'] && invite['Products'].split(',')
      if (isRegistered) {
        errorMessage = errorMessage + `${invite['Email Address']} is already registered.` + '<br>'
        errorCount++
      } else if (!productsColumn) {
        errorMessage = errorMessage + `${invite['Email Address']} cannot be registered because products is empty.` + '<br>'
        errorCount++
      } else if (productsColumn && productsColumn.every(r => subscribeProducts.includes(r)) === false) {
        const notSubscribed = productsColumn.filter(item => !subscribeProducts.includes(item))
        const intersection = productsColumn.filter(value => -1 !== subscribeProducts.indexOf(value));
        errorMessage = errorMessage + `${invite['Email Address']} can not use ${notSubscribed} because his school did not subscribe for this product.` + '<br>'
        errorCount++
        if (intersection.length > 0) {
          const url = `${fbFunctionsURL}/registerUser`
          this.props.firebase.auth().currentUser.getIdToken()
            .then( token => {
              const config = {
                url: `${fbFunctionsURL}/register/registerUser`,
                method: 'post',
                data: {
                  'email': invite['Email Address'],
                  'name': invite['First Name'],
                  'last_name': invite['Last Name'],
                  'id': this.validateId(invite['Teacher ID']),
                  'role': 'teacher',
                  'school_id': schoolId,
                  'school_name': schoolName,
                  'products': intersection
                },
                headers: {
                  authorization: `Bearer ${token}`
                }
              }
              axios(config)
            })
        }
      }
      else {
        const url = `${fbFunctionsURL}/registerUser`
        this.props.firebase.auth().currentUser.getIdToken()
          .then( token => {
            const config = {
              url: `${fbFunctionsURL}/register/registerUser`,
              method: 'post',
              data: {
                'email': invite['Email Address'],
                'name': invite['First Name'],
                'last_name': invite['Last Name'],
                'id': this.validateId(invite['Teacher ID']),
                'role': 'teacher',
                'school_id': schoolId,
                'school_name': schoolName,
                'products': productsColumn
              },
              headers: {
                authorization: `Bearer ${token}`
              }
            }
            axios(config)
          })
      }
    })
    if (data.length > errorCount) {
      message.success(t('Import successful'));
    }
    if (errorCount > 0) {
      this.setState({ errorMessage: errorMessage })
      //message.error(errorMessage);
    }
  }

  onSelectChange = (selectedRowKeys, type) => {

    if (selectedRowKeys.length === 0) {
      this.setState({ products: null })
    }
    this.setState({ selectedRowKeys });

  }


  resendInvites = () => {
    const { t } = this.props
    const checked = this.state.checked
    const schoolId = this.props.profile.profile.school.id
    checked.map( uid => {
      axios.post(`${fbFunctionsURL}/resendInvite`, {
        uid,
        schoolId,
        environment
      })
    })
    message.success(t('Invites resent'))
  }

  getColumns = type => {
    const { t } = this.props 
    let sort = type === 'registered' ? this.state.sortRegistered : this.state.sortInvited
    sort = sort || {};

    return [
        {
          title: t('Teacher ID'),
          dataIndex: 'customId',
          key: 'customId',
          sorter: true,
          sorter: (a, b) => a.customId.toString().localeCompare(b.customId.toString()),
          sortOrder: sort.columnKey === 'customId' && sort.order
        },
        {
          title: t('First Name'),
          dataIndex: 'first',
          key: 'first',
          sorter: true,
          sorter: (a, b) => a.first.toString().localeCompare(b.first.toString()),
          sortOrder: sort.columnKey === 'first' && sort.order
        },
        {
          title: t('Last Name'),
          dataIndex: 'last',
          key: 'last',
          sorter: true,
          sorter: (a, b) => a.last.toString().localeCompare(b.last.toString()),
          sortOrder: sort.columnKey === 'last' && sort.order
        },
        {
          title: t('Email Address'),
          dataIndex: 'email',
          key: 'email',
          sorter: true,
          sorter: (a, b) => a.email.toString().localeCompare(b.email.toString()),
          sortOrder: sort.columnKey === 'email' && sort.order
        },
        {
          title: t('Products'),
          dataIndex: 'products',
          key: 'products',
          sorter: true,
          sorter: (a, b) => a.products.toString().localeCompare(b.products.toString()),
          sortOrder: sort.columnKey === 'products' && sort.order,
          render: (record) => {
            return record && record.join(', ')
          }
        },
      {
          title: '',
          dataIndex: 'edit',
          key: 'edit',
          width: '50',
          onCell: (record) => {
            return {
              onClick: () => { this.openModal('edit', record) }
            };
          }
        },
        {
          title: '',
          dataIndex: 'delete',
          key: 'delete',
          width: '50',
          onCell: (record) => {
            return {
              onClick: () => { this.setState({ toRemove: record.id }) }
            };
          }
        }
    ]
  }

  render() {

    const { t } = this.props;
    let registered = [];
    let invited = [];
    if (this.props.teachers && this.props.profile) {
      //Put registered teachers to table
      let schoolId = this.props.profile.profile.school.id
      this.props.teachers.map((teacher, i) => {
        if (teacher[1].profile.changePassword) {
          invited.push(
            {
              key: teacher[0],
              invited: true,
              id: teacher[0],
              customId: teacher[1].profile.id,
              first: teacher[1].profile.name,
              last: teacher[1].profile.last_name,
              email: teacher[1].profile.email,
              products: teacher[1].profile.products || ['SkillTracker'],
              creatdedAt: teacher[1].createdAt,
              edit: <Icon style={{ fontSize: '24px' }} type="edit" />,
              delete: <Popconfirm placement="top" title={'Are you sure you want to remove this teacher?'} onConfirm={(e) => this.removeEntry(e)} okText={t("Yes")} cancelText={t("No")}>
                <Icon style={{ fontSize: '24px' }} type="delete" />
              </Popconfirm>
            }
          )
        } else {
          registered.push(
            {
              key: teacher[0],
              id: teacher[0],
              customId: teacher[1].profile.id,
              first: teacher[1].profile.name,
              last: teacher[1].profile.last_name,
              email: teacher[1].profile.email,
              products: teacher[1].profile.products || ['SkillTracker'],
              updateProductDate: teacher[1].profile.updateProductDate,
              edit: <Icon style={{ fontSize: '24px' }} type="edit" />,
              delete: <Popconfirm placement="top" title={'Are you sure you want to remove this teacher?'} onConfirm={(e) => this.removeEntry(e)} okText={t("Yes")} cancelText={t("No")}>
                <Icon style={{ fontSize: '24px' }} type="delete" />
              </Popconfirm>
            }
          )
        }
      })
    }

    let allSelected = this.state.checked.length == invited.length ? true : false


    const { selectedRowKeys, selectedRowKeys_invited, errorMessage } = this.state;
    const rowSelection = {
      selectedRowKeys,
      hideDefaultSelections: true,
      onChange: (rowSelection) => this.onSelectChange(rowSelection, 'registered'),
      onSelectAll: () => {
        this.setState({
          selectedRowKeys: selectedRowKeys.length == registered.length ? [] : registered.map((item) => item.key)
        });
      }
    };

    const hasSelected = selectedRowKeys.length > 0;
    const plainOptions = ['SkillTracker', 'ServiceTracker'];
    return (
      <div>
        <div style={styles.container} className='schoolAdmin'>
          <div style={styles.submenu}>
            <Upload accept=".csv" customRequest={this.importData} showUploadList={false} style={{ float: 'right' }}>
              <Button style={styles.buttonBlue} type="primary">
                <Icon type="upload" /> {t('Import CSV')}
          </Button>
            </Upload>
            <Button
              onClick={() => this.openModal('add')}
              style={styles.buttonBlue} type="primary"
            >
              <Icon type="user-add" />{t('Add Teacher')}
            </Button>
          </div>
          <div style={styles.errorMessage}>
            {errorMessage && <Alert
              message="Error in importing csv"
              description={Parser(errorMessage)}
              type="error"
              closable
              onClose={() => this.onCloseAlert()}
            />}
          </div>
          {serviceTracker_allowed &&
            <div style={styles.inner} >
              <h3 style={{fontSize: 22, fontWeight: 'bold'}}>{t('Products')}</h3>
              <CheckboxGroup disabled={!hasSelected} value={this.state.products} options={plainOptions} onChange={(e) => this.onChangeCheckbox(e)} />

              <span style={{ marginLeft: 8, marginBottom: 10 }}>
                {hasSelected ? `Selected ${selectedRowKeys.length} items to change their products` : ''}
              </span>
              <Button
                disabled={!hasSelected}
                onClick={() => this.groupChange(selectedRowKeys)}
                style={styles.buttonBlue} type="primary"
              >
                {t('Update')}
              </Button>
            </div>
          }

          <div style={styles.inner}>
            <h3 style={{ marginLeft: '5px', fontSize: 22, fontWeight: 'bold' }}>{t('Registered Teachers')} <Icon style={{position: 'relative', bottom: 5, marginLeft: 10}} type="check-circle" /></h3>
            <Table
              onChange={this.handleRegistered}
              rowSelection={rowSelection}
              id='log-table'
              columns={this.getColumns('registered')}
              dataSource={registered}
            />
          </div>


          <div style={styles.submenu}>
            <Button
              onClick={() => this.resendInvites()}
              style={styles.buttonBlueMargin} type="primary"
              disabled={this.state.checked.length == 0}
            >
              <Icon type="reload" />{t('Resend invites')}
            </Button>
          </div>
          <div style={styles.inner}>
            <h3 style={{ marginLeft: '5px', fontSize: 22, fontWeight: 'bold' }}>{t('Invited Teachers')} <Icon style={{position: 'relative', bottom: 5, marginLeft: 10}} type="mail" /></h3>
            <Table
              onChange={this.handleInvited}
              id='log-table'
              columns={this.getColumns('invited')}
              dataSource={invited}
              rowSelection={rowSelection}
            />
          </div>
        </div>
        <ModalUsers
          mode={this.state.modalMode}
          type={'teacher'}
          ref={instance => { this.modal = instance; }}
          data={this.state.modalData}
          open={this.state.modalOpen}
          save={this.saveModal}
          products={this.props.products}
          cancel={this.cancelModal}
          t={this.props.t}
        />
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props, state) => {
    const schoolId = pathOr(null,['firebase', 'profile', 'profile', 'school', 'id'] ,state.getState())
    let paths = [
      'auth', 'users', 'profile'
    ]
    if (schoolId) {
      paths.push(`/schools/${schoolId}`)
    }
    return paths
  }),
  connect(
    state => {
      const schoolId = pathOr(null,['firebase', 'profile', 'profile', 'school', 'id'] ,state)
      return {
      auth: state.firebase.auth,
      profile: state.firebase.profile,
      teachers: state.teachersOfSchool.teachers,
      users: state.firebase.data.users,
      products: pathOr(['SkillTracker'],['firebase', 'data','schools', schoolId, 'products'] ,state)
    }}
  )
)
export default enhancer(SchoolAdminTeacher);

const styles = {

  container: {
    padding: '20px'
  },

  buttonBlue: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px'
  },
  buttonBlueMargin: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px',
    marginRight: 20
  },

  buttonBlueMargin: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px',
    marginRight: 20
  },

  submenu: {
    marginBottom: '20px',
    overflow: 'hidden'
  },

  inner: {
    padding: 20,
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)',
    marginBottom: 40
  }
}



// WEBPACK FOOTER //
// ./src/containers/SchoolAdminTeacher/index.jsx